export default function getPaginationKey(type: any) {
  switch (type) {
    default:
    case 1:
      return '';
    case 2:
      return 'greekChapter';
    case 3:
      return 'greekOrganization';
    case 4:
      return 'council';
  }
}
